export function Footer() {
  return (
    <footer className=" px-[4vw] py-6 bg-[#DEE9FF] grid place-items-center gap-y-6 ">
      <div className="w-[60%] max-w-[160px]">
        <img
          src="images/creditry-logo-main.svg"
          alt="footer logo"
          className=" w-full"
        />
      </div>
      <p className=" text-center text-[#434046]">
        A financial service firm helping businesses grow.
      </p>
      {/* social icons */}
      <div className=" flex gap-x-6 ">
        <div>
          <img src="images/socials/instagram.svg" alt="instagram" />
        </div>
        <div>
          <img src="images/socials/linkedin-color.svg" alt="linkedin" />
        </div>
        <div>
          <img src="images/socials/twitter-color.svg" alt="twitter" />
        </div>
      </div>
      <div> &copy; 2023 </div>
    </footer>
  );
}
